import script from "./OidoModalHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./OidoModalHeader.vue?vue&type=script&setup=true&lang=js"

import "./OidoModalHeader.vue?vue&type=style&index=0&id=a7d91b70&scoped=true&lang=css"
import "./OidoModalHeader.vue?vue&type=style&index=1&id=a7d91b70&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7d91b70"]])

export default __exports__